/* Great Lakes Lavender Farm Simulator: "Ask the farm" button beside "Report a Bug".
   Opens the Lavender Grower chat (app embed) with the game's current screen as context. */
(() => {
  const BUTTON_ID = "lavender-simulator-ask-farm";
  const visibleText = (el) => (el && el.textContent || "").replace(/\s+/g, " ").trim().slice(0, 80);
  const gameContext = () => {
    const root = document.querySelector(".lfg-header")?.closest("section,div[id]") || document;
    const active = root.querySelector('[aria-selected="true"],[aria-current="page"],[aria-current="true"],.is-active,.active');
    const immersive = document.querySelector(".lfg-immersive canvas[data-im-canvas]");
    return {
      source: "Lavender Farm Simulator",
      screen: visibleText(active) || "Main farm",
      immersive_mode: Boolean(immersive && immersive.offsetParent !== null),
      viewport: `${innerWidth}x${innerHeight}`,
    };
  };
  const openChat = () => {
    if (window.GLLFGrower) return window.GLLFGrower.open({ topic: "Lavender Farm Simulator", context: gameContext() });
    location.href = "/pages/contact";
  };
  const install = () => {
    const bug = document.getElementById("lavender-simulator-bug-report");
    if (!bug || document.getElementById(BUTTON_ID)) return Boolean(bug);
    const button = document.createElement("button");
    button.type = "button";
    button.id = BUTTON_ID;
    button.className = `${bug.className} gllf-sim-ask-farm`;
    button.innerHTML = "<span>✦</span><b>Ask the farm</b>";
    button.setAttribute("aria-label", "Ask the farm about the game or growing lavender");
    button.addEventListener("click", (event) => { event.preventDefault(); event.stopPropagation(); openChat(); });
    bug.insertAdjacentElement("afterend", button);
    return true;
  };
  if (install()) return;
  const observer = new MutationObserver(() => { if (install()) observer.disconnect(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 60000);
})();
